import _sliced_to_array from "@swc/helpers/src/_sliced_to_array.mjs";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { ButtonSlide, CustomText, ImageAtoms } from "@vfit/shared/atoms";
import { purify } from "@vfit/shared/themes";
import { ButtonSlideContainer, Container, Title, TextContainer, ImageContainer, TitleCentered, TopContainer } from "./genericDetail.style";
var GenericDetail = function(param) {
    var title = param.title, description = param.description, submitButtonLabel = param.submitButtonLabel, submitButtonAction = param.submitButtonAction, secondButtonLabel = param.secondButtonLabel, secondButtonAction = param.secondButtonAction, options = param.options, imageUrl = param.imageUrl, _invertButtons = param.invertButtons, invertButtons = _invertButtons === void 0 ? false : _invertButtons, _titleAlwaysCenter = param.titleAlwaysCenter, titleAlwaysCenter = _titleAlwaysCenter === void 0 ? false : _titleAlwaysCenter, isButtonSticky = param.isButtonSticky;
    var ref = _sliced_to_array(purify([
        description,
        title
    ]), 2), pDescription = ref[0], pTitle = ref[1];
    return /*#__PURE__*/ _jsxs(Container, {
        children: [
            /*#__PURE__*/ _jsxs(TopContainer, {
                isButtonSticky: isButtonSticky,
                children: [
                    imageUrl && /*#__PURE__*/ _jsx(ImageContainer, {
                        children: /*#__PURE__*/ _jsx(ImageAtoms, {
                            nameCard: title,
                            image: imageUrl,
                            imageMobile: imageUrl,
                            style: {
                                width: "50.69px",
                                height: "47.9px"
                            },
                            isMobile: true
                        })
                    }),
                    titleAlwaysCenter && pTitle && /*#__PURE__*/ _jsx(TitleCentered, {
                        dangerouslySetInnerHTML: {
                            __html: pTitle
                        }
                    }),
                    !titleAlwaysCenter && pTitle && /*#__PURE__*/ _jsx(Title, {
                        dangerouslySetInnerHTML: {
                            __html: pTitle
                        },
                        textAlign: options === null || options === void 0 ? void 0 : options.textAlign
                    }),
                    pDescription && /*#__PURE__*/ _jsx(TextContainer, {
                        children: /*#__PURE__*/ _jsx(CustomText, {
                            text: pDescription,
                            size: (options === null || options === void 0 ? void 0 : options.size) || 18,
                            lineHeight: (options === null || options === void 0 ? void 0 : options.lineHeight) || 24,
                            sizeMobile: options === null || options === void 0 ? void 0 : options.sizeMobile,
                            lineHeightMobile: options === null || options === void 0 ? void 0 : options.lineHeightMobile,
                            modal: options === null || options === void 0 ? void 0 : options.isModal,
                            textAlign: options === null || options === void 0 ? void 0 : options.textAlign,
                            fontFamily: options === null || options === void 0 ? void 0 : options.fontFamily
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(ButtonSlideContainer, {
                children: [
                    !invertButtons && /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            secondButtonLabel && secondButtonAction && /*#__PURE__*/ _jsx(ButtonSlide, {
                                label: secondButtonLabel,
                                onClick: secondButtonAction,
                                borderColor: "#0d0d0d",
                                hoverColor: "#262626",
                                hoverTextColor: "#fff",
                                clickColor: "#7e7e7e",
                                clickTextColor: "#fff",
                                name: "action_second_genericDetail"
                            }),
                            submitButtonLabel && submitButtonAction && /*#__PURE__*/ _jsx(ButtonSlide, {
                                label: submitButtonLabel,
                                onClick: submitButtonAction,
                                hoverColor: "#bd0000",
                                clickColor: "#a10000",
                                buttonColor: "#e60000",
                                labelColor: "#fff",
                                name: "action_first_genericDetail"
                            })
                        ]
                    }),
                    invertButtons && /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            submitButtonLabel && submitButtonAction && /*#__PURE__*/ _jsx(ButtonSlide, {
                                label: submitButtonLabel,
                                onClick: submitButtonAction,
                                hoverColor: "#bd0000",
                                clickColor: "#a10000",
                                buttonColor: "#e60000",
                                labelColor: "#fff",
                                name: "action_first_genericDetail"
                            }),
                            secondButtonLabel && secondButtonAction && /*#__PURE__*/ _jsx(ButtonSlide, {
                                label: secondButtonLabel,
                                onClick: secondButtonAction,
                                borderColor: "#0d0d0d",
                                hoverColor: "#262626",
                                hoverTextColor: "#fff",
                                clickColor: "#7e7e7e",
                                clickTextColor: "#fff",
                                name: "action_second_genericDetail"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
export default GenericDetail;
